import { Injectable } from "@angular/core";
import { gql, Mutation, Apollo } from "apollo-angular";
import { Idea } from "src/generated/graphql";

export type GetAllIdeaFilesMutation = {
  getAllIdeaFiles: {
    id: string;
    file?: string;
    fileName: string;
    requestId: string;
    eTag: string;
    versionId: string;
    idea?: Idea;
  }[];
};

export type GetAllIdeaFilesMutationVariables = {
  id: string;
};

export const getAllIdeaFilesDocument = gql`
  query GetAllIdeaFiles($id: String!) {
    getAllIdeaFiles(id: $id) {
      id
      file
      fileName
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetAllIdeaFilesGQL extends Mutation<
  GetAllIdeaFilesMutation,
  GetAllIdeaFilesMutationVariables
> {
  document = getAllIdeaFilesDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
